// extracted by mini-css-extract-plugin
module.exports = {"desktop":"_3kslD","mobile":"_2JlSq"};